export const NUMBER_REGEX = "^[0-9]*$"
export const DECIMAL_NUMBER_REGEX = "^(?![.])(?!0[0-9])([0-9]*[.])?[0-9]*$"


